import Enum from 'enum';

export const main = new Enum(
    [
        'AUTH_LOGIN_READY',
        'UPDATE_AUTH_TOKEN',
        'CONFIRM_LOGIN_DOMAIN',
    ],
    {freeze: true}
);
